import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menu from '../myComponents/Menu';
import './SetupPlatformPage.css';
import Footer from '../myComponents/Footer';

const SetupRegion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="App">
      <div style={{ position: 'relative', zIndex: 1000 }}>
        <Menu />
      </div>
      
      <section className="platform-setup-section">
        <div className="platform-container">
          {/* Header */}
          <div className="platform-header">
            <div className="platform-breadcrumb">
              <Link to="/setup">
                ← Все инструкции
              </Link>
            </div>
            <h1 className="platform-title">Как сменить регион в App Store</h1>
            <p className="platform-description">
              Некоторые приложения недоступны в российском App Store. Не беда! <br/><br/>
              Мы покажем, как за 5 минут сменить регион и скачать любое приложение. Инструкция для самых ленивых - копируй, вставляй, готово! 🎭
            </p>
          </div>

          {/* Setup Steps */}
          <div className="setup-steps">
            
            <div className="tab-text-content">
              <h1>🌍 Зачем менять регион?</h1>
              <p>Многие крутые VPN-приложения заблокированы в российском App Store. Но Apple позволяет легально сменить страну и получить доступ ко всем приложениям мира!</p>
              
              <h1>📱 Быстрая смена региона</h1>
              <p>Идём в настройки iPhone → Apple ID → "Медиа и покупки" → "Просмотр аккаунта" → "Страна/регион" → "Изменить страну или регион"</p>
            </div>

            <div className="setup-section">
              <button
                className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                onClick={() => toggleSection(0)}
              >
                <h3>Шаг 1: Выбираем страну и адрес</h3>
                <span className="section-icon">
                  {activeIndex === 0 ? '−' : '+'}
                </span>
              </button>
              
              <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                <div className="section-content-inner">
                  <ol className="steps-list">
                    <li><strong>Выбираем США</strong> - там есть вообще всё</li>
                    <li><strong>Имя:</strong> Bob</li>
                    <li><strong>Фамилия:</strong> Lee</li>
                    <li><strong>Адрес:</strong> 123 Main St</li>
                    <li><strong>Город:</strong> Miami</li>
                    <li><strong>Штат:</strong> Florida</li>
                    <li><strong>Индекс:</strong> 33101</li>
                    <li><strong>Телефон:</strong> +1 305-555-0123</li>
                  </ol>
                </div>
              </div>
            </div>

            <div className="setup-section">
              <button
                className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                onClick={() => toggleSection(1)}
              >
                <h3>Шаг 2: Способ оплаты</h3>
                <span className="section-icon">
                  {activeIndex === 1 ? '−' : '+'}
                </span>
              </button>
              
              <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                <div className="section-content-inner">
                  <ol className="steps-list">
                    <li>В разделе "Способ оплаты" выбираем <strong>"Нет"</strong></li>
                    <li>Если этого варианта нет - сначала отмените все подписки в старом регионе</li>
                    <li>Потратьте остаток денег в российском App Store (купите стикеры в Telegram 😉)</li>
                    <li>Теперь точно появится вариант "Нет"</li>
                  </ol>
                  <div className="step-screenshot">
                    <p><strong>Важно:</strong> У вас на балансе должно быть ровно 0 рублей, иначе Apple не даст сменить регион!</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="setup-section">
              <button
                className={`section-header ${activeIndex === 2 ? 'active' : ''}`}
                onClick={() => toggleSection(2)}
              >
                <h3>Шаг 3: Альтернативные адреса</h3>
                <span className="section-icon">
                  {activeIndex === 2 ? '−' : '+'}
                </span>
              </button>
              
              <div className={`section-content ${activeIndex === 2 ? 'active' : ''}`}>
                <div className="section-content-inner">
                  <p><strong>Если не сработало, попробуйте:</strong></p>
                  <ol className="steps-list">
                    <li><strong>Max Fox:</strong><br/>
                    456 Oak Ave, Austin, TX 73301<br/>
                    Телефон: +1 512-555-0456</li>
                    <li><strong>Sam Gray:</strong><br/>
                    789 Pine Rd, Denver, CO 80201<br/>
                    Телефон: +1 303-555-0789</li>
                    <li><strong>Штат без налогов:</strong> Delaware - любой адрес, индекс 19901</li>
                  </ol>
                  <div className="step-screenshot">
                    <p><strong>Совет:</strong> Выбирайте штаты без налогов - приложения будут дешевле!</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="tab-text-content">
              <h1>🎉 Готово!</h1>
              <p>Теперь вы житель США со всеми вытекающими! Можете скачивать любые приложения из американского App Store.</p>
              <p><strong>Чтобы вернуться обратно:</strong> просто повторите процедуру, выбрав Россию и указав свой реальный адрес.</p>
              <p>Добро пожаловать в мир свободного интернета! 🇺🇸</p>
            </div>

            <div className="setup-section">
              <button
                className={`section-header ${activeIndex === 3 ? 'active' : ''}`}
                onClick={() => toggleSection(3)}
              >
                <h3>Частые проблемы и решения</h3>
                <span className="section-icon">
                  {activeIndex === 3 ? '−' : '+'}
                </span>
              </button>
              
              <div className={`section-content ${activeIndex === 3 ? 'active' : ''}`}>
                <div className="section-content-inner">
                  <ol className="steps-list">
                    <li><strong>"Не могу изменить страну"</strong> - отмените ВСЕ подписки и потратьте баланс до нуля</li>
                    <li><strong>"Требует банковскую карту"</strong> - сначала обнулите баланс, потом будет доступен вариант "Нет"</li>
                    <li><strong>"Адрес неверный"</strong> - используйте только реальные адреса, Google Maps в помощь</li>
                    <li><strong>"Приложение всё равно не скачивается"</strong> - перезагрузите App Store или iPhone</li>
                  </ol>
                  <div className="step-screenshot">
                    <p><strong>SOS:</strong> Если совсем ничего не работает - создайте новый Apple ID сразу в нужной стране!</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SetupRegion;